import React from 'react';
import apiclient from 'lib/apiclient';
import useAreas from 'hooks/useAreas';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { query } from 'js-query-builder';

const Table = (props) => {
  const history = useHistory();
  const location = useLocation();
  const {
    list
  } = props;

  return (
    <table className='table table-striped' aria-labelledby="tabelLabel">
      <thead>
        <tr>
          <th>ID</th>
          <th>管理番号</th>
          <th>企業名</th>
          <th>エリア</th>
          <th>体験版</th>
          <th>デモ</th>
        </tr>
      </thead>
      <tbody>
        {list.map(item =>
          <tr key={item.id} onClick={() => history.push(`${location.pathname}/view/${item.id}`)}>
            <td>{item.id}</td>
            <td>{item.managementNumber}</td>
            <td>{item.name}</td>
            <td>{item.area}</td>
            <td>{item.isFreeTrial ? '✓' : ''}</td>
            <td>{item.isDemo ? '✓' : ''}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default () => {
  const [data, setData] = React.useState({});
  const [areaFilter, setAreaFilter] = React.useState('');
  const areas = useAreas();
  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {
    apiclient.get(
      query('api/customer')
        .param('area', areaFilter)
        .build())
      .then(response => {
        setData({ list: response.data, loaded: true });
      });

  }, [areaFilter]);

  const contents = data.loaded
    ? <Table list={data.list} />
    : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" >顧客一覧</h1>
        <Form>
          <FormGroup>
            <Label>エリア</Label>
            <Input type="select" id="area" value={areaFilter} onChange={e => setAreaFilter(e.target.value)}>
              <option value="">(ALL)</option>
              {areas.map(area => <option key={area.id} value={area.id}>{area.name}</option>)}
            </Input>
          </FormGroup>
        </Form>
        <Button onClick={() => history.push(`${location.pathname}/new`)}>新規</Button>
        {contents}
      </div>
    );
}